function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { TweenMax } from 'gsap';
var LanguageSelector = /*#__PURE__*/function (_React$Component) {
  function LanguageSelector(props) {
    var _this;
    _classCallCheck(this, LanguageSelector);
    _this = _callSuper(this, LanguageSelector, [props]);
    _this.state = {
      isOpen: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.openMenu = _this.openMenu.bind(_this);
    _this.languageMenuRef = null;
    return _this;
  }
  _inherits(LanguageSelector, _React$Component);
  return _createClass(LanguageSelector, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      document.addEventListener('mousedown', this.handleDocumentClick, false);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      TweenMax.set(this.languageMenuRef, {
        autoAlpha: 0,
        y: '-5'
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleDocumentClick, false);
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      var _this2 = this;
      TweenMax.to(this.languageMenuRef, 0.2, {
        y: -5,
        autoAlpha: 0,
        onComplete: function onComplete() {
          return _this2.setState({
            isOpen: false
          });
        }
      });
    }
  }, {
    key: "openMenu",
    value: function openMenu() {
      TweenMax.to(this.languageMenuRef, 0.2, {
        y: 0,
        autoAlpha: 1
      });
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      e.preventDefault();
      if (this.state.isOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(e) {
      if (this.node.contains(e.target) || !this.state.isOpen) {
        return;
      }
      this.closeMenu();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var isOpen = this.state.isOpen;
      var htmlDivElement = this.props.htmlDivElement;
      var listItems = _toConsumableArray(htmlDivElement.querySelectorAll('li a'));
      return /*#__PURE__*/React.createElement("div", {
        className: "language-selector",
        ref: function ref(node) {
          return _this3.node = node;
        }
      }, /*#__PURE__*/React.createElement("button", {
        className: "language-selector__toggle-button",
        onClick: this.handleClick,
        title: "language"
      }, "language"), /*#__PURE__*/React.createElement("ul", {
        className: "language-selector__list",
        ref: function ref(ul) {
          return _this3.languageMenuRef = ul;
        },
        style: {
          display: isOpen ? 'flex' : 'none'
        }
      }, listItems.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: "language-selector__item",
          key: index
        }, /*#__PURE__*/React.createElement("a", {
          className: "language-selector__link",
          href: item.href,
          title: item.text
        }, item.text));
      })));
    }
  }]);
}(React.Component);
LanguageSelector.propTypes = {
  htmlDivElement: PropTypes.instanceOf(HTMLDivElement).isRequired
};
export default LanguageSelector;